import { render, staticRenderFns } from "./SettingsBoundedFractionalDeposit.vue?vue&type=template&id=3ee5cadc"
import script from "./SettingsBoundedFractionalDeposit.vue?vue&type=script&lang=js"
export * from "./SettingsBoundedFractionalDeposit.vue?vue&type=script&lang=js"
import style0 from "./SettingsBoundedFractionalDeposit.vue?vue&type=style&index=0&id=3ee5cadc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports